module.exports = __webpack_public_path__ + "img/iconYou.c482f653.png";